import { BaseColour } from './viewConfiguration';

export enum TagType {
    InboundShipment = 'inbound_shipment',
    Item = 'item',
    Merchant = 'merchant',
    Order = 'order',
    OutboundShipment = 'outbound_shipment',
}

export interface Tag {
    id: number
    createdAt: string
    updatedAt: string
    name: string
    type: TagType
    colour: BaseColour
    isAvailableForMerchants: boolean
}
